import {
  AppointmentOverview,
  Title,
  DateTimePicker,
  PersonalDataForm,
  Remark,
  ServiceCenterPicker,
} from '@/components';

import router from '@/router';

import validationFlow from '@/validation-flow';

import {
  mapGetters,
  mapMutations,
  mapActions,
} from 'vuex';

export default {
  name: 'step6AppointmentInfoUpdate',
  components: {
    [AppointmentOverview.name]: AppointmentOverview,
    [Title.name]: Title,
    [DateTimePicker.name]: DateTimePicker,
    [PersonalDataForm.name]: PersonalDataForm,
    [Remark.name]: Remark,
    [ServiceCenterPicker.name]: ServiceCenterPicker,
  },
  props: {},
  data: () => ({}),
  computed: {
    ...mapGetters('appointment', {
      customerDataRaw: 'getCustomerDataRaw',
      loadingState: 'getLoadingState',
      isValidAppointment: 'getIsValidAppointment',
      appointmentUpdateObject: 'getAppointmentUpdateObject',
    }),
  },
  methods: {
    ...mapActions('appointment', {
      updateAppointment: 'UPDATE_APPOINTMENT',
    }),
    ...mapMutations('appointment', {
      setCat: 'SET_CAT',
    }),
    goToPreviousStep() {
      this.$router.push({
        name: 'hasAppointment',
      });
    },
    moveAppointment() {
      if (this.isValidAppointment && !this.loadingState) {
        this.setCat('depot');
        const object = this.appointmentUpdateObject;
        this.updateAppointment(object)
          .then(() => {
            validationFlow.validateStep6AppointmentInfo();
          }).catch(() => {
            router.push({
              name: 'error',
            });
          });
      }
    },
  },
};
